var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.813 5.75c0 .383-.301.656-.657.656H6.781v4.375c0 .383-.3.684-.656.684-.383 0-.656-.3-.656-.684V6.406H1.094c-.383 0-.657-.273-.657-.629 0-.382.274-.683.657-.683h4.375V.719c0-.356.273-.63.656-.63.355 0 .656.274.656.63v4.375h4.375c.356 0 .656.3.656.656z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.7361e4ed8e535eff29e3ce264b593d83.svg";
export { ForwardRef as ReactComponent };